<template>
  <form class="form-horizontal">
    <card>
      <div slot="header">
        <h4 class="card-title">Adição remoto no carrinho</h4>
      </div>
      <div>

        <fg-input v-if="showMatriz" name="company" label="Empresa">
          <el-select
            class
            size="large"
            style="width: 100%"
            placeholder="Selecione a empresa dos usuários"
            v-model="company"
          >
            <el-option
              v-for="option in companyList"
              class
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </fg-input>

        <fg-input
          name="vm"
          label="Vending machine">

          <el-select class=""
                      size="large"
                      style="width: 100%"
                      placeholder="Selecione a vending machine"
                      @input="getPlan()"
                      v-model="machine">
            <el-option v-for="option in machines"
                        class=""
                        :value="option.id"
                        :label="option.location"
                        :key="option.id">
            </el-option>
          </el-select>
        </fg-input>
        <fg-input
          v-if="machine"
          name="shelf"
          label="Produto">

          <el-select class=""
                      size="large"
                      style="width: 100%"
                      placeholder="Selecione o produto"
                      @input="showProduct = true"
                      v-model="product">
            <el-option v-for="(option,index) in haveProduct"
                        class=""
                        :value="index"
                        :label="option.product__name"
                        :key="option.id">
            </el-option>
          </el-select>
        </fg-input>
        <div v-if="showProduct">
          <div v-if="product >= 0">
            <p><b>Produto :</b> {{haveProduct[product].product__name}} <b>- Quantidade:</b> {{ haveProduct[product].amount }}</p> 
            <p v-if="haveProduct[product].amount == 0"><b>Quantidade insuficiente</b></p>
          </div>
        </div>
        <fg-input 
          name="qtd"
          label="Quantidade" 
          type="number" v-model="quantity"></fg-input>
      </div>
    </card>
    <card>
      <div>
        <button type="submit"
          @click.prevent="validate" class="btn btn-fill btn-info btn-wd">Adicionar remotamente</button>
      </div>
    </card>
  </form>
</template>
<script>
import { Select, Option } from "element-ui";
import swal from "sweetalert2";
export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
  },
  data() {
    return {
      machines: [],
      machine: '',
      shelves: [],
      companyList: [],
      products: [],
      plano: [],
      company: '',
      shelf: '',
      coils: [],
      coil: '',
      act: [],
      product: '',
      showProduct: false,
      quantity: 1,
    };
  },
  mounted () {
    this.$watch('company',()=>{
      this.machines = []
      this.$store.dispatch('general/flag', {id: this.company}).then(()=>{
        this.getData(this.company)
      })
    })
    this.getListCompany()
    var ciaID = localStorage.getItem('smartmachCiaID')
    if (ciaID) { 
      this.getData(ciaID)
    } else {
      this.getData()
    }
  },
  computed: {
    showMatriz () {
      const matriz = localStorage.getItem("parent_company")
      if (matriz != 'null') {
        return true
      } else {
        return false
      }
    },
    haveProduct() {
      return this.products
        .filter(produto => produto.product__name !== null)
        .reduce((acc, produto) => {
          const existingProduct = acc.find(p => p.product__name === produto.product__name);
          if (existingProduct) {
            existingProduct.amount += produto.amount;
          } else {
            acc.push({ ...produto });
          }
          return acc;
        }, []);
    }
  },
  methods: {
    getData (ciaID) {
      if (ciaID) {
        ciaID = ciaID
      } else {
        ciaID = ''
      }
      this.$store.dispatch("machines/listSort",{sort: '?company=' + ciaID}).then(resp => {

        var y = this.$store.state.general.flag.filter(el => {
          if (el.feature === "V05"){
            if (el.active === true) {
              return el
            }
          }
        })
        var x = []
        this.machines = resp.map(el =>{
          return y.filter(ar =>{
            if (ar.vm == el.id) {
              x.push(el)
            }
          })

        })
        console.log('x',x)
        this.machines = x
      })
    },
    getListCompany () {
      this.$store.dispatch("company/list").then(resp => {
        this.companyList = resp.sort((a,b) => (a.name > b.name) ? 1 : (b.name > a.name) ? -1 : 0)
    
      })
    },
    getPlan () {
      console.log('dado machine', this.machine)
      this.$store.dispatch('machines/getPlan',{sort: '?vm='+ this.machine}).then(resp =>{
        console.log('plano', resp.shelves)
        this.plano = resp
        for (const item of resp.shelves) {
          for (const coil of item.coils) {
            this.products.push(coil);
          }
        }
      })
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    notifySuccess() {
      this.$notify({
        message: "Sucesso</br>Senha alterada!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    notifyError() {
      this.$notify({
        message: "Erro</br>Preencha todos os dados antes!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "danger"
      });
    },
    notifyError2() {
      this.$notify({
        message: "Erro</br>Quantidade insuficiente!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "danger"
      });
    },
    async validate () {
      console.log('data prod', this.haveProduct)
      if (this.product.amount == 0) {
        this.notifyError2()
      } else {
        var data = {
          product_id: this.haveProduct[this.product].product,
          vm_id: this.machine,
          quantity: Number(this.quantity)

        }
        swal.fire({
          title: 'Atenção!',
          text: `Você está prestes a acionar um produto remotamente, 
          especificado no carrinho.`,
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonText: 'Sim, acionar!',  
          showLoaderOnConfirm: true,
          preConfirm: (login) => {
            return this.$store.dispatch('machines/addCart', {item:data})
              .then(response => {
                console.log('res', response)
                if (response.result[0].status_code !== 200) {
                  throw new Error(response.statusText)
                }
              })
              .catch(error => {
                swal.showValidationMessage(
                  `Falha na comunicação: ${error}`
                )
              })
          },
          allowOutsideClick: () => !swal.isLoading()
        }).then((result) => {
          if (result.value) {
            swal.fire({
              title: `Item foi adicionado no carrinho.`,
            })
          }
        })
      }     
    }
  }
};
</script>
<style scoped>
.el-select {
  margin-bottom: 10px;
}
img {
  width: 200px;
}
.img-upload {
  border: 1px solid #ccc;
  border-radius: 5px;
  display: inline-block;
  padding: 10px;
  margin-bottom: 20px;
}
</style>
